.pointerEvents {
  pointer-events: all;
  cursor: pointer;

  @include themify($themes) {
    fill: themed("main-primary");
  }
}
